import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GlobalDropdownComponent } from '../global-dropdown/global-dropdown.component';
import { MatSliderComponent } from '@shared-lib/global-components/mat-slider/mat-slider.component';
import { ButtonComponent } from '@shared-lib/global-components/button/button.component';
import { SearchContainerComponent } from '@shared-lib/global-components/search-container/search-container.component';
import { MultiselectToggle } from '@shared-lib/global-components/multiselect-toggle/multiselect-toggle';
import { GlobalFilterComponent as ParentGlobalFilterComponent } from '../global-filter/global-filter.component';

@Component({
  selector: 'app-global-filter-v2',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    GlobalDropdownComponent,
    MatSliderComponent,
    ButtonComponent,
    SearchContainerComponent,
    MultiselectToggle,
  ],
  templateUrl: './global-filter-v2.component.html',
  styleUrls: ['./global-filter-v2.component.scss']
})
export class GlobalFilterV2Component extends ParentGlobalFilterComponent {}
